export default __webpack_public_path__ + "static/media/logo.58aa33df.gif";